'use strict';

const ProtocolCtrl = function ($rootScope, $scope, $state, $stateParams, CRUDService, config) {
    var ctrl = this;

    var url = config.urls.protocol + "/search/findByLoggerName?logger=net.gesundheitsforen.emil.model.EntityProtocolListener";
    ctrl.i = 0;

    var currentPage = 0;
    var totalPages;

    function getAll() {
      CRUDService.getAll(url, undefined, 'timestmp,desc').then(function (data) {
        ctrl.protocol = data._embedded.logging;
        totalPages = data.page.totalPages;
      });
    }

    getAll();

    ctrl.getNextPage = function () {
      if ((currentPage + 1) < totalPages) {
        currentPage++;
        CRUDService.getAll(url, currentPage, 'timestmp,desc').then(function (data) {
          ctrl.protocol = ctrl.protocol.concat(data._embedded.logging);
        });
      }
    };

    $scope.$watch(
      function(){ return ctrl.i; },
      function(val){
        if (val === 7){
          url = config.urls.protocol;
          getAll();
        }
      });
  };

ProtocolCtrl.$inject = ['$rootScope', '$scope', '$state', '$stateParams', 'CRUDService', 'config'];

module.exports = {
  template: require('./protocol.html'),
  controller: ProtocolCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/settings/components/protocol/protocol.component.js